import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useEnquiry } from "../context/EnquiryContext";

const LINKS = [
  { label: "Films", href: "#films" },
  { label: "Services", href: "#services" },
  { label: "Venues", href: "#venues" },
  { label: "Packages", href: "#packages" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" }
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { open: openEnquiry } = useEnquiry();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#f5efe6]/95 backdrop-blur border-b border-cream" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <span
            className={`font-display text-2xl md:text-[1.6rem] tracking-tight ${
              scrolled ? "text-[#1f1d1a]" : "text-[#f5efe6]"
            }`}
          >
            Vow <span className="italic text-[#c9a87c]">&amp;</span> Video
            <span className="ml-1 font-light">Essex</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`text-[0.72rem] tracking-[0.25em] uppercase font-medium transition-colors ${
                scrolled ? "text-[#1f1d1a] hover:text-[#8b6f47]" : "text-[#f5efe6] hover:text-[#c9a87c]"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button onClick={openEnquiry} className={scrolled ? "btn-primary" : "btn-ghost"} style={!scrolled ? { color: "#f5efe6", borderColor: "#f5efe6" } : {}}>
            Secure Your Date
          </button>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2"
          aria-label="Menu"
        >
          {open ? (
            <X className={scrolled ? "text-[#1f1d1a]" : "text-[#f5efe6]"} size={26} />
          ) : (
            <Menu className={scrolled ? "text-[#1f1d1a]" : "text-[#f5efe6]"} size={26} />
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#f5efe6] border-t border-cream">
          <div className="flex flex-col px-6 py-6 gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#1f1d1a] text-sm tracking-[0.25em] uppercase font-medium"
              >
                {l.label}
              </a>
            ))}
            <button onClick={() => { setOpen(false); openEnquiry(); }} className="btn-primary mt-2 w-full justify-center">
              Secure Your Date
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
